import { useTranslation } from 'react-i18next';
import {
  ModalReviewContent,
  ModalReviewLabel,
  ModalReviewStyles,
} from './Styles';
import ConfirmReviewImage from '../../assets/img/confirmReview.svg';

type Props = {
  show: boolean;
  onChangeShow(show: boolean): void;
  onCreate(): void;
  onClose(value: boolean): void;
};

export const ModalReview = ({
  show,
  onChangeShow,
  onCreate,
  onClose,
}: Props) => {
  const { t } = useTranslation();

  return (
    <ModalReviewStyles
      show={show}
      onChangeShow={onChangeShow}
      footer={{
        closeButtonLabel: '',
        submitButtonLabel: t('Confirm'),
        onSubmitButton: () => onClose(false),
      }}
    >
      <ModalReviewContent
        flexDirection="column"
        rowGap="2.4"
        alignItems="center"
      >
        <img src={ConfirmReviewImage} alt="confirm" />
        <ModalReviewLabel fontSize="14">
          {t('The review is ended!')}
        </ModalReviewLabel>
      </ModalReviewContent>
    </ModalReviewStyles>
  );
};
